// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f9d5f0d1","453":"1adf7b1f","667":"0c1f22a9"}[chunkId] + ".chunk.js";
};